import { MapUtils } from '../../utility/map-utils.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { RenderableComponent } from '../core/component.js';
import { FeaturedOption } from '../../models/serializable/featured-option.js';

export class FeaturedContactOptionsComponent extends RenderableComponent {
  static readonly TYPE_ID: string = '3e66fd46ba984035b71e79229cf30fea';

  constructor(
      public readonly tikTok: FeaturedOption,
      public readonly facebook: FeaturedOption,
      public readonly instagram: FeaturedOption,
      public readonly website: FeaturedOption,
      public readonly emailAddress: FeaturedOption,
      public readonly phoneNumber: FeaturedOption,
      public readonly isRenderingEnabled: boolean,
      public readonly renderOrder: number,
  ) {
    super();
  }

  get $typeId(): string {
    return FeaturedContactOptionsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FeaturedContactOptionsComponent {
    return new FeaturedContactOptionsComponent(
        context.fromData<FeaturedOption>(MapUtils.get<SerializedData>(map, 'tikTok')),
        context.fromData<FeaturedOption>(MapUtils.get<SerializedData>(map, 'facebook')),
        context.fromData<FeaturedOption>(MapUtils.get<SerializedData>(map, 'instagram')),
        context.fromData<FeaturedOption>(MapUtils.get<SerializedData>(map, 'website')),
        context.fromData<FeaturedOption>(MapUtils.get<SerializedData>(map, 'emailAddress')),
        context.fromData<FeaturedOption>(MapUtils.get<SerializedData>(map, 'phoneNumber')),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
        MapUtils.get<number>(map, 'renderOrder'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'tikTok': context.toData(this.tikTok),
      'facebook': context.toData(this.facebook),
      'instagram': context.toData(this.instagram),
      'website': context.toData(this.website),
      'emailAddress': context.toData(this.emailAddress),
      'phoneNumber': context.toData(this.phoneNumber),
      'isRenderingEnabled': this.isRenderingEnabled,
      'renderOrder': this.renderOrder,
    };
  }

  clone(): this {
    return new FeaturedContactOptionsComponent(
        this.tikTok.clone(),
        this.facebook.clone(),
        this.instagram.clone(),
        this.website.clone(),
        this.emailAddress.clone(),
        this.phoneNumber.clone(),
        this.isRenderingEnabled,
        this.renderOrder,
    ) as this;
  }

  isSame(other: FeaturedContactOptionsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.tikTok, this.tikTok) &&
        isSameData(other.facebook, this.facebook) &&
        isSameData(other.instagram, this.instagram) &&
        isSameData(other.website, this.website) &&
        isSameData(other.emailAddress, this.emailAddress) &&
        isSameData(other.phoneNumber, this.phoneNumber) &&
        other.renderOrder === this.renderOrder &&
        other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class FeaturedContactOptionsComponentBuilder extends DataModelBuilder<FeaturedContactOptionsComponent> {
  build(context: SerializationContext, map: SerializedData): FeaturedContactOptionsComponent {
    return FeaturedContactOptionsComponent.fromMap(context, map);
  }
}
